require('./myProfileAdditionalDocumentationView.scss')
const PropTypes = require('prop-types');
//@vendors
const React = require('react');
const {connect} = require('react-redux');
const Immutable = require('immutable');
const {sortByOrder} = require('lodash/collection');
const { withRouter } = require('react-router-dom');
//@components
const {OKHeaderSubPage} = require('commonsComponents/OKHeaderSubPage');
const DocumentsTable = require('components/myProfile/documentsTable/documentsTable');
const {LoadingSection} = require('commonsComponents/loadingSection');
const {CallMeBack} = require('components/callMeBack/callMeBack');
const WebappRender = require('components/conditionalRender/webappRender')
//@commons
const {formatText, FormattedText} = require('core/i18n').i18n;
const {EmptyState} = require('commonsComponents/emptyState');
const {OKCover} = require('commonsComponents/OKCover');
const {OKSectionBox} = require('commonsComponents/OKSectionBox');
const {OKButton} = require('components/commons/OKButton/OKButton');
//@actions
const documentActions = require('actions/additionalDocumentation');
const okApiDocumentsActions = require('actions/okApiDocuments');
const {ANNUAL_INFO, LEGAL_CORRESPONDENCE} = require('constants/index');
//@constants
const { VIEWER } = require('constants/contactCenter/pdfViewer');

class MyProfileAdditionalDocumentationView extends React.Component {

    constructor(props) {
        super(props);

        this.handleRequestDocuments = this.handleRequestDocuments.bind(this);
        this.callbackDownloadFile = this.callbackDownloadFile.bind(this);
        this.handleOpenPDFViewer = this.handleOpenPDFViewer.bind(this);
    }

    componentDidMount() {
        this.handleRequestDocuments();
    }

    buildBreadcrumb() {
        const { location } = this.props;
        const currentPath = location.pathname.substring(1).split('/')[2];

        const bread = {
            legalCorrespondence: {
                text: formatText('breadcrumb-correspondence'),
                url: '',
                key: 'breadcrumb-correspondence'
            },
            annualInformation: {
                text: formatText('breadcrumb-annualInformation'),
                url: '',
                key: 'breadcrumb-annualInformation'
            }
        };

        const mappingBreadcrumb = [{
            text: formatText('breadcrumb-documentation'),
            url: '/myprofile/documentation/'
        }, bread[currentPath]];

        return mappingBreadcrumb;
    }

     downloadById = (documentId)=> {
        this.props.getDocumentsOkApiById(documentId)
      }

    modelHasErrorSet() {
        const {documents} = this.props;
        return documents.get('error') && ['body', 'error', 'text'].every(key => documents.getIn(['error', key]))
    }

    buildDocumentList() {
        const {documents} = this.props,
            condition = [
                documents.get('isFetching'),
                documents.get('additionalDocumentation').size > 0,
                documents.get('noDocuments'),
                this.modelHasErrorSet()
            ].findIndex(statement => !!statement);

        return [
            () => <LoadingSection/>,
            this.buildTable.bind(this, documents.get('additionalDocumentation')),
            this.buildEmptyState.bind(this),
            this.buildErrorState.bind(this)
        ][condition > -1 && condition || 0]();
    }

    buildEmptyState() {
        return (
            <div className="extracts-list__content">
                <EmptyState primaryText={formatText('profileExtracts-extractsEmptyDocuments')} iconType="search-banking"/>
            </div>
        );
    }

    buildErrorState() {
        const retryButton = (
            <OKButton
                id="btn_myProfileAdditionalDocumentationView_retry"
                onClick={this.handleRequestDocuments}
            >
                <FormattedText value="profileExtracts-retry"/>
            </OKButton>
        );

        return (
            <div className="extracts-list__content">
                <EmptyState
                    button={retryButton}
                    primaryText={formatText('profileExtracts-errorMessage')}
                    iconType="nointernet-banking"/>
            </div>
        );
    }

    getValueByProperty(immDocument, prop) {
        return immDocument.get('fields').filter(field => field.get('name') === prop).first().get('value');
    }

    buildDataPayload(immDocument) {
        if(immDocument.get('internalIdx')){
            return {
                currentDocument: false,
                fechaAlta: this.getValueByProperty(immDocument, 'FECHADOCUM'),
                nombreTipoComunicacion: this.getValueByProperty(immDocument, 'DENOMINACION'),
                isFetching: immDocument.get('isFetching'),
                file: {
                    "process": immDocument.get('process'),
                    "internalIdx": immDocument.get('internalIdx'),
                    "segmentId": immDocument.get('segmentId'),
                    "pageTo": immDocument.get('pageTo') || 0,
                    "queryId": immDocument.get('queryId')
                },
            };
        }
        return immDocument
    }

    buildTable(documents) {
        let data = !documents ? [] : documents.map(immDocument => this.buildDataPayload(immDocument));
        data = sortByOrder(data.toJS(), ['fechaAlta'], ['desc']);
        data[0].currentDocument = true;

        return (
            <DocumentsTable
                data={Immutable.fromJS(data)}
                showAlias={false}
                showCurrentDocument={true}
                showDocumentationType={true}
                callbackDownloadFile={__CONTACT_CENTER__ ? this.handleOpenPDFViewer : this.callbackDownloadFile}
                downloadById={this.downloadById}
                
            />
        );
    }

    callbackDownloadFile(params, filename) {
        this.props.getFileSaddeDocuments(params, filename);
    }

    handleOpenPDFViewer(params, filename){
        this.props.getFileSaddeDocuments(params, filename, VIEWER);
    }

    isAnnualInformation() {
        const { location } = this.props;
        return location.pathname.substring(1).split('/')[2] === ANNUAL_INFO;
    }

    handleRequestDocuments() {
        let param = this.isAnnualInformation() ? ANNUAL_INFO : LEGAL_CORRESPONDENCE;
        this.props.requestAdditionalDocumentation(param);
    }

    render() {
        const mappingBreadcrumb = this.buildBreadcrumb();
        const titleKey = mappingBreadcrumb[1].key === 'breadcrumb-correspondence' ? 'profileDocumentation-legalCorrespondence' : 'profileDocumentation-infoAnual';
        const finalTitle = <FormattedText value={titleKey}/>

        return (
            <React.Fragment>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={finalTitle}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-lg-8">
                                <OKSectionBox title={formatText('documents-title')}>
                                    <div className="additional-documents-view__table">
                                        {this.buildDocumentList()}
                                    </div>
                                </OKSectionBox>
                            </div>
                            <WebappRender>
                                <div className="col-lg-4">
                                    <div className="additional-documents-view__wrapper-callmeback">
                                        <CallMeBack pageTitle={formatText('breadcrumb-correspondence')} hasEntrance={false} />
                                    </div>
                                </div>
                            </WebappRender>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

MyProfileAdditionalDocumentationView.propTypes = {
    documents: PropTypes.object,
    requestAdditionalDocumentation: PropTypes.func,
    requestDownloadingPdf: PropTypes.func,
    getFileSaddeDocuments: PropTypes.func,
    getDocumentsOkApiById: PropTypes.func,

    location: PropTypes.object.isRequired,
};

module.exports.MyProfileAdditionalDocumentationView = connect(state => ({
    documents: state.additionalDocumentation
}), {
    requestAdditionalDocumentation: documentActions.requestAdditionalDocumentation,
    getDocumentsOkApiById: okApiDocumentsActions.getDocumentsOkApiById,
    getFileSaddeDocuments: documentActions.getFileSaddeDocuments
})(withRouter(MyProfileAdditionalDocumentationView));
